import React from 'react';
import Moment from 'react-moment';
import { AuthContext } from '../Auth.js'
import { Grid, List, ListItem, Divider, Container, Link} from '@material-ui/core';

import Turn from './Turn.js';


function Day (d) {
    const fecha = d.dayInfo.fecha.toDate();
    const {userProfile} = React.useContext(AuthContext);

    const verFecha = () => {
        if (!userProfile.organizador) {
            return(
                <>
                <Container spacing={0} >
                    <h4><Moment format="ddd">{fecha}</Moment></h4>
                    <h2><Moment format="DD">{fecha}</Moment></h2>
                    <h4><Moment format="MMM">{fecha}</Moment></h4>
                </Container>
                </>
            )
        }
        if (userProfile.organizador) {
            return(
                <>
                 <Link href={"/day/" + d.dayInfo.id} style={{ color: 'inherit', textDecoration: 'inherit'}}>
                    <Container spacing={0} >
                    <h4><Moment format="ddd">{fecha}</Moment></h4>
                    <h2><Moment format="DD">{fecha}</Moment></h2>
                    <h4><Moment format="MMM">{fecha}</Moment></h4>
                    </Container>
                </Link>
                </>
            )
        }
    }

    if (!userProfile) {
        return (
            <></>
        )
    }

    return (
        <>
        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={0}>
            <Grid item xs={3} >
               {verFecha()}
            </Grid>
            <Divider orientation="vertical" flexItem />
            <Grid item xs>
                <List>
                    <ListItem>
                    {
                    <Turn diaId={d.dayInfo.id} turnoId={"1"} fecha={d.dayInfo.fecha} />
                    }
                    </ListItem>
                    <ListItem>
                    {
                    <Turn diaId={d.dayInfo.id} turnoId={"2"} fecha={d.dayInfo.fecha} />
                    }
                    </ListItem>
                    <ListItem>
                    {
                    <Turn diaId={d.dayInfo.id} turnoId={"3"} fecha={d.dayInfo.fecha} />
                    }
                    </ListItem>
                </List>
            </Grid>
        </Grid>
        </>
    );

}


  

export default Day; 
